import chroma from 'chroma-js';
import {
	CrossHatchThickPattern,
	CrossHatchThinPattern,
} from './CrossHatchPattern';
import {
	StripesBackwardThickPattern,
	StripesBackwardThinPattern,
} from './StripesBackwardPattern';
import {
	StripesForewardThickPattern,
	StripesForewardThinPattern,
} from './StripesForewardPattern';
import { CheckersPatternThin, CheckersPatternThick } from './CheckersPattern';
import { cbsColors } from '../../cbsGraph.config';

export const patterns = [
	{
		color: cbsColors.blue,
		lightColor: chroma(cbsColors.blue).brighten(2).hex(),
		darkColor: chroma(cbsColors.blue).darken().hex(),
		id: 'pattern-stripes-foreward-thick',
		Pattern: StripesForewardThickPattern,
	},
	{
		color: cbsColors.blue,
		lightColor: chroma(cbsColors.blue).brighten(2).hex(),
		darkColor: chroma(cbsColors.blue).darken().hex(),
		id: 'pattern-stripes-foreward-thin',
		Pattern: StripesForewardThinPattern,
	},
	{
		color: cbsColors.violet,
		lightColor: chroma(cbsColors.violet).brighten(2).hex(),
		darkColor: chroma(cbsColors.violet).darken().hex(),
		id: 'pattern-cross-hatch-thick',
		Pattern: CrossHatchThickPattern,
	},
	{
		color: cbsColors.violet,
		lightColor: chroma(cbsColors.violet).brighten(2).hex(),
		darkColor: chroma(cbsColors.violet).darken().hex(),
		id: 'pattern-cross-hatch-thin',
		Pattern: CrossHatchThinPattern,
	},
	{
		color: cbsColors.green,
		lightColor: chroma(cbsColors.green).brighten(2).hex(),
		darkColor: chroma(cbsColors.green).darken().hex(),
		id: 'pattern-tripes-backward-thick',
		Pattern: StripesBackwardThickPattern,
	},
	{
		color: cbsColors.green,
		lightColor: chroma(cbsColors.green).brighten(2).hex(),
		darkColor: chroma(cbsColors.green).darken().hex(),
		id: 'pattern-tripes-backward-thin',
		Pattern: StripesBackwardThinPattern,
	},
	{
		color: cbsColors.purple,
		lightColor: chroma(cbsColors.purple).brighten(2).hex(),
		darkColor: chroma(cbsColors.purple).darken().hex(),
		id: 'pattern-checkers-thick',
		Pattern: CheckersPatternThick,
	},
	{
		color: cbsColors.purple,
		lightColor: chroma(cbsColors.purple).brighten(2).hex(),
		darkColor: chroma(cbsColors.purple).darken().hex(),
		id: 'pattern-checkers-thin',
		Pattern: CheckersPatternThin,
	},
];

export const Patterns = () => {
	return (
		<defs>
			{patterns.map(({ Pattern, id, color, lightColor }) => {
				return (
					<Pattern
						key={id}
						foregroundColor={color}
						backgroundColor={lightColor}
						id={id}
					/>
				);
			})}
		</defs>
	);
};

export const getPatternId = (index: number) => `pattern-${index}`;
